/**
 * Classe
 */
import BaseNode from '@/types/BaseNode';
import Dictionary from '@/types/Dictionary';
import Vue from 'vue';

/**
 * Interface définissant le contrat pour toutes les stratégies de recherche.
 * Permet de déléguer la logique de recherche et de traitement des résultats.
 */
export abstract class SearchStrategy extends Vue {
    
    /**
     * Propriété pour stocker le nom du composant d'affichage du résultat
     */
    protected displayer: string = "";

    /**
     * Propriété pour stocker le nom de l'event suivant la stratégie de recherche
     */
    protected event: string = "";

    /**
     * Exécute la logique de recherche en utilisant la valeur de recherche et les arguments fournis.
     * @param parameters Les arguments supplémentaires nécessaires pour l'appel API (TypesList, Expendables, Grouping, etc.).
     * @returns Une promesse qui résout en un tableau de BaseNode (le type des résultats attendus).
     */
    public Execute(parameters: Dictionary<any>): Promise<BaseNode[]> {
        return this.execute(parameters);
    }

    /**
     * Exécute la logique de recherche en utilisant la valeur de recherche et les arguments fournis.
     * @param parameters Les arguments supplémentaires nécessaires pour l'appel API (TypesList, Expendables, Grouping, etc.).
     * @returns Une promesse qui résout en un tableau de BaseNode (le type des résultats attendus).
     */
    protected abstract execute(parameters: Dictionary<any>): Promise<BaseNode[]>;

    /**
     * Récupération du nom du composant pour l'affichage du résultat
     */
    public getDisplayer(): string{
        return this.displayer;
    }

    /**
     * Récupération du nom de l'event suivant la stratégie de recherche
     */
    public getEvent(): string{
        return this.event;
    }
}
